import { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  Navigate,
  Outlet,
  Route,
  Routes,
  useLocation,
  useNavigate
} from "react-router-dom";
import "./App.css";
import Appointment from "./Screens/Appointment/Appointment";
import Home from "./Screens/Home/Home";
import Login from "./Screens/Login/Login";
import Query from "./Screens/Query/Query";
import QuerySuccess from "./Screens/Query/QuerySuccess";
import Symptom from "./Screens/Symptom/Symptom";
import TestFHIRRenderer from "./Screens/TestFHIRRenderer/TestFHIRRenderer";
import SnackBar from "./front-end-global-components/components/SnackBar/SnackBar";
import "./front-end-global-components/design-system.css";
import "./index.css";
import { useAuthSubscriber } from "./services/authentication";
// eslint-disable-next-line
// import perf from "./services/performance";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import reloadUpdate from "../src/assets/icons/reload_update.svg";
import FitnessTrackers from "./Screens/FitnessTrackers/FitnessTrackers";
import Forms from "./Screens/Forms/Forms";
import ScanClinic from "./Screens/ScanClinic/ScanClinic";
import Settings from "./Screens/Settings/Settings";
import Vitals from "./Screens/Vitals/Vitals";
import googleFit from "./assets/images/googleFit.png";
import Button from "./front-end-global-components/components/Button/Button";
import Modal from "./front-end-global-components/components/Modal/Modal";
import RoundedProfilePicture from "./front-end-global-components/components/RoundedProfilePicture/RoundedProfilePicture";
import {
  //  logout,
  setOAuthAccessToken
} from "./redux/authentication/actions";
import { initializeGoogleApi } from "./redux/fitness/actions";
import { colors, lockerSetup } from "./utils/constants";
// import { logUserData } from "./services/analytics";
// import errorBoundaryFallBack from "./assets/icons/permissionDeniedFallBack.svg";
import ResetPassword from "./Screens/Abdm/ResetPassword";
import Incidents from "./Screens/Incidents/Incidents";
import UnsupportedDevice from "./front-end-global-components/components/UnsupportedDevice/UnsupportedDevice";
import { useListener } from "./hooks/useListener";
import { getPublicHealthProgram } from "./redux/abdm/actions";
import {
  setFeatureFlags,
  setIncidents,
  setNotificationPermission
} from "./redux/app/actions";
import { setDataTransfer, setDocuments } from "./redux/documents/actions";
import {
  addRegistrationData,
  putRegistrationData
} from "./redux/intent/actions";
import { setNotifications } from "./redux/notifications/actions";
import {
  addAutoApprovalPolicies,
  addPatientsDemographics,
  addPatientsSubscription,
  changePhoneNumber,
  generateNewLinkingToken,
  getHealthIdInformation,
  getPatientsCareContexts,
  getPatientsConsentArtefact,
  setLinkingTokenDetails
} from "./redux/patients/actions";
import { setErrorStatus } from "./redux/status/actions";
import { useRemoteConfig } from "./services/remoteConfig";
import { isValidObject } from "./utils/validators";
// import TestScreen from "./Screens/TestScreen/TestScreen";

function App(props) {
  const [status, setStatus] = useState(null);
  const [remoteConfig, setRemoteConfig] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const regToken = new URLSearchParams(window.location.search)?.get("regToken");
  const [isSubscriptionValid, setIsSubscriptionValid] = useState(null);
  const { isLoggedIn } = useAuthSubscriber();
  const [isListenersRunning, setIsListenersRunning] = useState(null);

  useEffect(() => {
    console.log(location);

    if (location.pathname.includes("uhi")) {
      const hiuId = location.pathname.split("/").pop();
      navigate(`/clinicSearch/${hiuId}/patientDetails`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  useEffect(() => {
    if (
      isValidObject(isListenersRunning) &&
      Object.values(isListenersRunning).every((d) => d === false) &&
      props.app.shouldListen === false
    ) {
      changePhoneNumber(true, navigate);
    }
    // eslint-disable-next-line
  }, [isListenersRunning, props.app.shouldListen]);

  // feature flag listener
  useListener(
    {
      key: "config",
      isListening: true,
      collectionName: "config",
      collectionDocId: "featureFlags"
    },
    ({ type, payload, isListenerRunning }) => {
      // setIsListenersRunning((prev) => ({
      //   ...prev,
      //   config: isListenerRunning
      // }));

      if (type === "CONFIG_UPDATED") {
        setFeatureFlags(payload.featureFlags);
      } else if (type === "ERROR") {
        console.error("Error in config listener:", payload);
        setErrorStatus(payload);
      }
    }
  );

  // Incident Listener.
  useListener(
    {
      key: "incidents",
      isListening: isLoggedIn && props.app.shouldListen,
      collectionName: "incidents"
    },
    ({ type, payload, isListenerRunning }) => {
      setIsListenersRunning((prev) => ({
        ...prev,
        incidents: isListenerRunning
      }));

      if (type === "INCIDENTS_UPDATED") {
        setIncidents(payload);
      } else if (type === "ERROR") {
        console.error("Error in incidents listener:", payload);
        setErrorStatus(payload);
      }
    }
  );

  useRemoteConfig((remoteConfig) => {
    setRemoteConfig(remoteConfig);
  }, isLoggedIn);

  //notifications listener custom hook
  useListener(
    {
      key: "notifications",
      subCollectionName: "notifications",
      collectionDocId:
        props.patients.profiles && Object.keys(props.patients.profiles),
      isListening: Boolean(
        isLoggedIn && props.auth.data.phoneNumber && props.app.shouldListen
      ),
      enableLogs: false,
      filterQuery: [
        "userType",
        "==",
        "patient",
        "phoneNumber",
        "==",
        props.auth.data.phoneNumber
      ],
      orderBy: "timestamp",
      sortBy: "desc",
      dataLimit: 20
    },
    ({ type, payload, isListenerRunning }) => {
      setIsListenersRunning((prev) => ({
        ...prev,
        notifications: isListenerRunning
      }));

      if (type === "NOTIFICATIONS_UPDATED") {
        setNotifications(payload);
      } else if (type === "ERROR") {
        console.error("Error in notifications listener:", payload);
        setErrorStatus(payload);
      }
    }
  );

  useListener(
    {
      key: "transferred_documents",
      subCollectionName: "uploadedDocuments",
      isListening: Boolean(
        isLoggedIn && props.auth.data.phoneNumber && props.app.shouldListen
      ),
      filterQuery: [
        "patient.phoneNumber",
        "==",
        props.auth.data.phoneNumber,
        "clinicId",
        "==",
        lockerSetup.locker
      ],
      // orderBy: "createdAt",
      // sortBy: "desc",
      enableLogs: false
    },
    ({ type, payload, isListenerRunning }) => {
      setIsListenersRunning((prev) => ({
        ...prev,
        transferred_documents: isListenerRunning
      }));
      if (type === "TRANSFERRED_DOCUMENTS_UPDATED") {
        const docs = Object.values(payload || {}).reduce((acc, data) => {
          const id = data.patient?.patientId;
          const docId = data.documentId;

          if (id && docId) {
            if (!acc[id]) acc[id] = {};
            acc[id][docId] = data;
          }

          return acc;
        }, {});

        setDocuments(docs);
      } else if (type === "ERROR") {
        console.error(
          "Error in transferred documents listener error:",
          payload
        );
      }
    }
  );

  useListener(
    {
      key: "data_transfer",
      subCollectionName: "dataTransfers",
      isListening: Boolean(
        isLoggedIn && props.auth.data.phoneNumber && props.app.shouldListen
      ),
      filterQuery: [
        "patient.phoneNumber",
        "==",
        props.auth.data.phoneNumber,
        "hiuClinicId",
        "==",
        lockerSetup.locker,
        "expired",
        "==",
        false
      ],
      // orderBy: "createdAt",
      // sortBy: "desc",
      enableLogs: false
    },
    ({ type, payload, isListenerRunning }) => {
      setIsListenersRunning((prev) => ({
        ...prev,
        data_transfer: isListenerRunning
      }));
      if (type === "DATA_TRANSFER_UPDATED") {
        const transfers = Object.values(payload || {});
        setDataTransfer(transfers);
      } else if (type === "ERROR") {
        console.error("Error in data transfer listener:", payload);
      }
    }
  );

  useListener(
    {
      key: "linking_token",
      subCollectionName: "authorisations",
      isListening: Boolean(
        isLoggedIn && props.auth.data.phoneNumber && props.app.shouldListen
      ),
      filterQuery: [
        "patient.phoneNumber",
        "==",
        props.auth.data.phoneNumber,
        "hipId",
        "==",
        lockerSetup.locker,
        "status",
        "==",
        "GRANTED"
      ],
      enableLogs: false
    },
    ({ type, payload, isListenerRunning }) => {
      setIsListenersRunning((prev) => ({
        ...prev,
        linking_token: isListenerRunning
      }));
      if (type === "LINKING_TOKEN_UPDATED") {
        const tokens = {};
        Object.values(payload || {}).forEach((doc) => {
          if (doc?.patient?.patientId && doc.accessToken && doc.limit !== 0) {
            tokens[doc.patient.patientId] = doc;
          }
        });
        setLinkingTokenDetails(tokens);
      } else if (type === "ERROR") {
        console.error("Error in linking token listener:", payload);
      }
    }
  );

  // Demographic listener custom hook
  useListener(
    {
      key: "patient_demographics",
      collectionName: "patients",
      isListening: Boolean(
        isLoggedIn && props.auth.data.phoneNumber && props.app.shouldListen
      ),
      filterQuery: ["phoneNumber", "==", props.auth.data.phoneNumber],
      enableLogs: false
    },
    ({ type, payload, isListenerRunning }) => {
      setIsListenersRunning((prev) => ({
        ...prev,
        linking_token: isListenerRunning
      }));
      if (type === "PATIENT_DEMOGRAPHICS_UPDATED") {
        const profiles = {};
        let index = 0;

        Object.values(payload || {}).forEach((doc) => {
          profiles[doc.documentId] = {
            ...doc,
            color: colors?.[index]
          };
          index++;
        });

        addPatientsDemographics(profiles);
      } else if (type === "ERROR") {
        console.error("Error in patient demographics listener:", payload);
      }
    }
  );

  useListener(
    {
      key: "patient_subscriptions",
      subCollectionName: "subscriptions",
      isListening: Boolean(
        isLoggedIn && props.auth.data.phoneNumber && props.app.shouldListen
      ),
      filterQuery: ["patient.phoneNumber", "==", props.auth.data.phoneNumber],
      enableLogs: false
    },
    ({ type, payload, isListenerRunning }) => {
      setIsListenersRunning((prev) => ({
        ...prev,
        patient_subscriptions: isListenerRunning
      }));
      if (type === "PATIENT_SUBSCRIPTIONS_UPDATED") {
        const subscription = {};
        Object.values(payload || {}).forEach((doc) => {
          subscription[doc.documentId] = { ...doc };
        });

        addPatientsSubscription(subscription);
      } else if (type === "ERROR") {
        console.error("Error in patient subscriptions listener:", payload);
      }
    }
  );

  useListener(
    {
      key: "auto_approval_policies",
      subCollectionName: "autoApprovalPolicies",
      isListening: Boolean(
        isLoggedIn && props.auth.data.phoneNumber && props.app.shouldListen
      ),
      filterQuery: ["patient.phoneNumber", "==", props.auth.data.phoneNumber],
      enableLogs: false
    },
    ({ type, payload, isListenerRunning }) => {
      setIsListenersRunning((prev) => ({
        ...prev,
        auto_approval_policies: isListenerRunning
      }));
      if (type === "AUTO_APPROVAL_POLICIES_UPDATED") {
        const autoApprovalPolicies = {};
        Object.values(payload || {}).forEach((doc) => {
          autoApprovalPolicies[doc.documentId] = { ...doc };
        });

        addAutoApprovalPolicies(autoApprovalPolicies);
      } else if (type === "ERROR") {
        console.error("Error in auto approval policies listener:", payload);
      }
    }
  );

  //useEffect for relaying user data to analytics
  // useEffect(() => {
  //   if (props.auth.data.phoneNumber && props.auth.data.uid) {
  //     logUserData(props.auth.data.phoneNumber, props.auth.data.uid);
  //   }
  // }, [props.auth.data.phoneNumber, props.auth.data.uid]);

  useEffect(() => {
    const {
      currentProfile,
      accessToken,
      healthIdData,
      careContexts,
      consentArtefact,
      profiles
    } = props.patients;

    // valid profile + token
    if (
      !currentProfile ||
      typeof accessToken?.[currentProfile]?.token !== "string"
    ) {
      return;
    }

    // Fetch missing profile-scoped data
    if (!healthIdData?.[currentProfile]) {
      getHealthIdInformation();
    }

    if (!careContexts?.[currentProfile]) {
      getPatientsCareContexts();
    }

    if (!consentArtefact?.[currentProfile]) {
      getPatientsConsentArtefact();
    }

    // Fetch public health programs only if profile is valid
    if (isValidObject(profiles?.[currentProfile])) {
      getPublicHealthProgram();
    }

    // eslint-disable-next-line
  }, [props.patients.currentProfile, props.patients.accessToken]);

  useEffect(() => {
    const { currentProfile, subscription } = props.patients;

    // Reset by default
    let nextValidSubscription = null;

    // valid profile
    if (typeof currentProfile !== "string") {
      setIsSubscriptionValid(null);
      return;
    }

    const profileSubscriptions = subscription?.[currentProfile];

    // no subscriptions
    if (!isValidObject(profileSubscriptions)) {
      setIsSubscriptionValid(null);
      return;
    }

    nextValidSubscription =
      Object.values(profileSubscriptions).find((s) => {
        const expiry = s?.subscription?.sources?.[0]?.period?.to;
        return (
          s?.subscription?.hiu?.id === lockerSetup.locker &&
          s?.status === "GRANTED" &&
          typeof expiry === "string" &&
          new Date(expiry).getTime() > Date.now()
        );
      }) || null;

    setIsSubscriptionValid((prev) =>
      prev === nextValidSubscription ? prev : nextValidSubscription
    );

    // eslint-disable-next-line
  }, [props.patients?.subscription, props.patients?.currentProfile]);

  useEffect(() => {
    const { currentProfile, profiles, accessToken, linkingToken } =
      props.patients;

    // valid profile
    if (
      typeof currentProfile !== "string" ||
      !isValidObject(profiles?.[currentProfile])
    ) {
      return;
    }

    // only relevant on upload route
    const isUploadRoute = location.pathname.includes("/patientTimeline/upload");
    if (!isUploadRoute) {
      return;
    }

    // subscription + access token required
    const hasAccessToken =
      typeof accessToken?.[currentProfile]?.token === "string";

    if (!isValidObject(isSubscriptionValid) || !hasAccessToken) {
      return;
    }

    const linkingTokenData = linkingToken?.[currentProfile];
    const linkingAccessToken = linkingTokenData?.accessToken;

    const isLinkingTokenExpired =
      isValidObject(linkingTokenData) &&
      linkingTokenData.tokenExpiry < Date.now();

    if (!linkingAccessToken) {
      console.warn(`No linking token for ${currentProfile}`);
    } else if (isLinkingTokenExpired) {
      console.warn(
        `Linking token expired for ${currentProfile} at ${new Date(
          linkingTokenData?.expiresAt?.timestamp
        )}`
      );
    } else {
      console.warn(
        `Linking token valid for ${currentProfile} till ${new Date(
          linkingTokenData?.expiresAt?.timestamp
        )}`
      );
    }

    // Generate new token only when required
    if (
      typeof linkingAccessToken !== "string" ||
      !isValidObject(linkingTokenData) ||
      isLinkingTokenExpired
    ) {
      console.log("Generating new linking token");
      generateNewLinkingToken();
    }

    // eslint-disable-next-line
  }, [
    location.pathname,
    props.patients.currentProfile,
    props.patients.accessToken,
    isSubscriptionValid
  ]);

  //useEffect for error handling
  useEffect(() => {
    if (props.status.message) {
      setStatus(props.status.message);
    } else {
      setStatus(null);
    }
  }, [props.status]);

  useEffect(() => {
    if (!window.location.search) {
      return;
    }
    const params = new URLSearchParams(window.location.search);
    const entries = params.entries();
    const data = Object?.fromEntries(entries);
    if (data?.regToken && data.device && data.deviceId) {
      putRegistrationData(
        {
          regToken: data?.regToken,
          device: data?.device,
          deviceId: data?.deviceId
        },
        navigate
      );
    }
    if (data?.notificationPermission) {
      setNotificationPermission(data.notificationPermission, navigate);
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (
      props.auth.data.accessToken &&
      props.intent.data.regToken &&
      props.intent.data.device
    ) {
      addRegistrationData();
    }
    // eslint-disable-next-line
  }, [props.auth.data.accessToken, props.intent.data.regToken]);

  const isLocalOrStandalone = () => {
    const isLocal = window.location.hostname === "localhost";
    const isCypress = !!window.Cypress;
    const isUnsupported = window.Cypress?.unSupportedDeviceFallback === true;
    const isStandalone = window.matchMedia(
      "(display-mode: standalone)"
    ).matches;

    return (
      (isLocal && !isCypress) ||
      (isLocal && isCypress && !isUnsupported) ||
      isStandalone
    );
  };

  return props.auth.customAuthLoading !== false ? (
    <TimelineSuspense />
  ) : isLocalOrStandalone ? (
    <div
      className="inherit-parent-height inherit-parent-width"
      onContextMenu={(event) => {
        if (window.location.hostname === "localhost") {
          return;
        }
        event.preventDefault();
      }}
    >
      <TransitionGroup className="inherit-parent-height">
        <CSSTransition timeout={300} classNames="fade-in-fade-out-transition">
          <Routes>
            {/* Public routes */}
            {!regToken && (
              <Route
                element={
                  <PublicRoute accessToken={props.auth.data.accessToken} />
                }
              >
                <Route path="/login" element={<Login />} />
              </Route>
            )}

            {/* Protected routes */}
            {!regToken && (
              <Route
                element={
                  <ProtectedRoute
                    accessToken={props.auth.data.accessToken}
                    remoteConfig={remoteConfig}
                  />
                }
              >
                <Route
                  path="/*"
                  element={
                    <Home
                      remoteConfig={remoteConfig}
                      isSubscriptionValid={isSubscriptionValid}
                    />
                  }
                />

                {/* <Route
                  path="/home"
                  element={<Test remoteConfig={remoteConfig} />}
                /> */}

                <Route path="/resetPassword" element={<ResetPassword />} />
                <Route path="/symptom" element={<Symptom />} />
                <Route path="/symptoms/:documentId" element={<Symptom />} />
                {/* <Route path="/testFHIR" element={<TestFHIRRenderer />} /> */}

                <Route
                  path="/appointment/:documentId"
                  element={<Appointment />}
                />

                <Route path="/i/:inviteCode" element={<Home />} />
                <Route path="/query" element={<Query />} />
                <Route path="/fitnesstrackers" element={<FitnessTrackers />} />
                <Route
                  path="/querysuccess"
                  element={
                    <QuerySuccess
                      confirmClick={() => {
                        navigate("/");
                      }}
                    />
                  }
                />
                <Route path="/vitals" element={<Vitals />} />
                <Route path="/settings/*" element={<Settings />} />
                <Route path="/forms/:documentId" element={<Forms />} />
                <Route path="/scanClinic" element={<ScanClinic />} />
                <Route
                  path="/incidents/*"
                  element={<Incidents incidents={props.app.incidents} />}
                />

                {/* fallback */}
                <Route path="*" element={<Navigate to="/" replace />} />
              </Route>
            )}
          </Routes>
        </CSSTransition>
      </TransitionGroup>

      <GoogleOAuthRefreshModal
        show={props.auth.oAuth.accessToken === "expired"}
        remindMeLaterOnClick={() => {
          setOAuthAccessToken(null);
        }}
        reconnectOnClick={() => {
          initializeGoogleApi();
        }}
      />

      {/* <div>
        <div>Token:{props.intent?.data?.regToken}</div>
        <div>device:{props.intent?.data?.device}</div>
      </div> */}

      <SnackBar
        type={props.status.code === null ? "success" : "error"}
        message={status}
        status={props.status}
      />
      <div
        id="critical-update-card"
        className=" display-none z-index-101 inherit-parent-height inherit-parent-width background-color-black-with-opacity-light position-absolute-center-self "
      >
        <footer className="position-absolute  inherit-parent-width bottom-0 padding-large">
          <div
            id="critical-update-card-contents-wrapper"
            className="background-color-white inherit-parent-width padding-large border-radius-default display-flex flex-direction-column flex-align-items-center "
          >
            <img
              src={reloadUpdate}
              alt="update"
              className=" margin-bottom-default"
            />
            <p className="font-family-gilroy-medium font-size-medium font-color-secondary text-align-center margin-bottom-default ">
              {" "}
              Critical update available{" "}
            </p>
            <p className="font-family-gilroy-regular font-size-medium font-color-secondary text-align-center margin-bottom-default ">
              New critical changes updated and ready to launch.
            </p>
            <button
              id="critical-update-confirm-button"
              className="inherit-parent-width padding-vertical-medium font-family-gilroy-bold border-radius-default font-size-medium cursor-pointer background-color-primary font-color-white box-shadow-none"
            >
              Okay
            </button>
          </div>
        </footer>
      </div>
    </div>
  ) : (
    <UnsupportedDevice appName="patients" />
  );
}

const ProtectedRoute = ({ accessToken, children }) => {
  if (!accessToken) return <Navigate to="/login" replace />;
  return children || <Outlet />;
};

const PublicRoute = ({ accessToken, children }) => {
  if (accessToken) return <Navigate to="/" replace />;
  return children || <Outlet />;
};

const mapStateToProps = (state) => ({
  abdm: state.abdm,
  intent: state.intent,
  status: state.status,
  auth: state.auth,
  patients: state.patients,
  profile: state.profile,
  app: state.app
});

export default connect(mapStateToProps)(App);

const GoogleOAuthRefreshModal = (props) => {
  return (
    <Modal
      show={props.show}
      width="inherit-parent-width"
      maxWidth="max-width-630px"
      background="false"
      boxShadow="false"
      borderRadius="false"
      height="height-fit-to-content"
      modalBodyClassName="padding-horizontal-medium"
    >
      <div className="background-white padding-medium border-radius-default box-shadow-default font-family-gilroy-regular font-color-secondary">
        <div className=" font-size-medium text-align-center padding-bottom-large">
          Action required for fitness tracking
        </div>
        <div className=" font-size-small text-align-center ">
          Google fit tracking session has been expired. Please re-connect to
          resume fitness tracking.
        </div>
        <div className="display-flex flex-grow-1 flex-align-items-center padding-bottom-larger cursor-pointer ">
          <RoundedProfilePicture
            className="margin-top-default"
            size={"medium"}
            src={googleFit}
          />
          <div className="flex-grow-1 flex-direction-column display-flex padding-left-medium  ">
            <span className="font-size-medium font-family-gilroy-regular font-color-secondary text-transform-capitalize">
              Google fit
            </span>
          </div>
        </div>
        <div className="display-flex">
          <Button
            data-cy="edit-profile-logout-button"
            boxShadow={false}
            loading={props.logoutButtonLoading}
            className="margin-right-small font-family-gilroy-medium"
            variant="primary"
            text="Re-connect"
            onClick={() => {
              if (typeof props.reconnectOnClick === "function") {
                props.reconnectOnClick();
              }
            }}
          />
          <Button
            data-cy="edit-profile-cancel-button"
            boxShadow={false}
            className="margin-left-small font-family-gilroy-medium"
            variant="secondary"
            text="Remind me later"
            onClick={() => {
              if (typeof props.remindMeLaterOnClick === "function") {
                props.remindMeLaterOnClick();
              }
            }}
          />
        </div>
      </div>
    </Modal>
  );
};

// const UnAuthorizedFallBack = () => {
//   return (
//     <main className="inherit-parent-height inherit-parent-width flex-place-children-page-center padding-left-larger padding-right-larger">
//       <div>
//         <div className="padding-bottom-larger flex-center-children-horizontally">
//           <img
//             src={errorBoundaryFallBack}
//             className="error-fallback-image-height"
//             alt="error-fallback"
//             width="auto"
//           />
//         </div>

//         <div>
//           <div
//             style={{ fontSize: 24 }}
//             className="font-weight-normal font-family-gilroy-bold text-align-center font-color-secondary font-size-larger padding-bottom-large"
//           >
//             Access Denied !
//           </div>
//           <div className="text-align-center font-size-larger">
//             You are not authorized for further access.
//           </div>
//           <div className="text-align-center font-size-larger">
//             Please check back after sometime.
//           </div>
//         </div>
//         <div className=" text-align-center padding-top-larger">
//           <Button
//             boxShadow={false}
//             text="Take me back"
//             onClick={() => {
//               logout();
//             }}
//           />
//         </div>
//       </div>
//     </main>
//   );
// };

const TimelineSuspense = () => {
  return (
    <article
      className="screen-loader-wrapper flex-center-children-horizontally inherit-parent-height inherit-parent-width overflow-hidden"
      data-cy="patient-timeline-suspense"
    >
      <main className="max-width-588px inherit-parent-width">
        {[...Array(5)].map((_data, index) => (
          <div
            className=" padding-top-larger padding-left-large padding-right-large border-bottom-1px-e5e5e5"
            key={index}
          >
            <div className=" display-flex flex-justify-content-space-between ">
              <div className="shimmer  padding-default border-radius-default padding-right-larger padding-left-larger ">
                <div className="padding-left-larger padding-right-larger" />
              </div>
              <div className="shimmer  border-radius-default padding-right-larger padding-left-larger padding-top-large ">
                <div className="padding-left-larger padding-right-large" />
              </div>
            </div>

            <div className="flex-center-children-vertically padding-top-large  padding-bottom-larger">
              <div className="shimmer padding-large border-radius-50-percentage height-width-16px" />
              <div className=" margin-left-default">
                <div className="shimmer  padding-default border-radius-default width-200px " />
                <div className="shimmer margin-top-default padding-small border-radius-default width-150px ">
                  <div className=" padding-smaller" />
                </div>
              </div>
            </div>
          </div>
        ))}
      </main>
    </article>
  );
};
